
export const SELECTED_BLOG = "SELECTED_BLOG";
export function selectedBlog(blog) {
    return dispatch => {
        dispatch({ type: SELECTED_BLOG, data: blog });
    }
}